import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=c112eaec"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c112eaec')) {
      api.createRecord('c112eaec', component.options)
    } else {
      api.reload('c112eaec', component.options)
    }
    module.hot.accept("./Content.vue?vue&type=template&id=c112eaec", function () {
      api.rerender('c112eaec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/Content.vue"
export default component.exports